
const Loading = () => {
  return ( <div className="tac mt mb">Loading..</div> );
}

export default Loading;